import type { ExtendedWindow } from '@/@types/global';

declare let window: ExtendedWindow;

const favoritesReportedGroups = new Set<string>();

// `_paq` is a queue replayed once matomo.js loads, so pushing early (cold-start
// push tap) is safe. It is only missing when Matomo is not installed.
function pushMatomoEvent(category: string, action: string, name: string, value?: number) {
  const command =
    value === undefined
      ? ['trackEvent', category, action, name]
      : ['trackEvent', category, action, name, value];
  window._paq?.push?.(command);
}

export function trackPushOpen(groupId: string | undefined, alertId?: string) {
  const name = groupId ? (alertId ? `${groupId}/${alertId}` : groupId) : 'unknown';
  pushMatomoEvent('push', 'open', name);
}

type FavoriteFlags = { [key: string]: boolean };

const countFavorites = (flags: FavoriteFlags = {}) => Object.values(flags).filter(Boolean).length;

// On-demand lines are shown with the lines on the home screen, so they count as routes.
export function trackFavoritesUsage(
  groupId: string,
  favorites: { routes: FavoriteFlags; stops: FavoriteFlags; onDemandRoutes?: FavoriteFlags },
) {
  if (favoritesReportedGroups.has(groupId)) return;
  favoritesReportedGroups.add(groupId);
  pushMatomoEvent(
    'favorites',
    'routes',
    groupId,
    countFavorites(favorites.routes) + countFavorites(favorites.onDemandRoutes),
  );
  pushMatomoEvent('favorites', 'stops', groupId, countFavorites(favorites.stops));
}
